import { Box, Typography } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { ClientRoleSymbolProps } from './types';

export default function ClientRoleSymbol(props: ClientRoleSymbolProps) {
    const {
        id,
        className,
        role
    } = props;

    const classes = muiStyles(props);

    return (
        <Typography
            className={`${classes.root} ${className}`}
            variant='h4'
        >
            <Box
                className={classes.text}
                data-testid='client-role-symbol-value'
                id={id}
            >{role}
            </Box>
        </Typography>
    );
}